import { createDOMBuilder, createHTMLBuilder, RenderMode, } from "@knyt/weaver";
import { __isKnytElementDefinition } from "../constants.js";
export function defineElementDefinition(tagName, ElementConstructor, options = {}) {
    // TODO: Extract this to an environment utility package
    const $customElements = options.customElements ?? globalThis.customElements;
    if (typeof $customElements === "undefined") {
        throw new Error("`customElements` is not available in the current environment. This likely means Knyt Glazier has not been properly initialized.");
    }
    if (
    // If HMR is enabled, we need to redefine the element
    // to ensure the latest version is used.
    //
    // The HMR system _should_ polyfill the `customElements.define` method
    // so that it can handle redefinitions.
    import.meta.hot ||
        // Otherwise, we only define the element if it hasn't been defined yet.
        // This is to prevent errors when the element is defined multiple times.
        !$customElements.get(tagName)) {
        try {
            $customElements.define(tagName, ElementConstructor);
        }
        catch (error) {
            console.error(error);
        }
    }
    const domBuilder = createDOMBuilder(tagName);
    const htmlBuilder = createHTMLBuilder(tagName);
    const def = () => configureElementBuilder(domBuilder, options)();
    def.html = () => configureElementBuilder(htmlBuilder, options)();
    def.Element = ElementConstructor;
    def.tagName = tagName;
    def[__isKnytElementDefinition] = true;
    return def;
}
function configureElementBuilder(builder, options) {
    const defaultRenderMode = options.defaultRenderMode;
    return () => {
        if (defaultRenderMode) {
            return builder.$renderMode(defaultRenderMode);
        }
        return builder;
    };
}
